import React from 'react';
import { render } from 'react-dom';

import VideoPlayer from '../react/VideoPlayer';

export default class VideoPlayerRender {
  constructor(context) {
    this.context = context;
    this.init();
  }

  init() {
    const { model } = this.context.dataset;
    if (!model) throw Error('Missing a required dataset');
    const jsonModel = JSON.parse(model);

    render(
      <VideoPlayer videoUrl={jsonModel.videoUrl} fallbackImage={jsonModel.fallbackImage} />,
      this.context
    );
  }
}
